<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 교정기간 -->
				<el-col :span="5">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001626') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<!-- 관리번호 -->
				<el-col :span="3">
					<search-input
						:label="`${getMessage_('QWCC001314')} / ${getMessage_('QWCC001317')}`"
						paramKey="mesEqipNm"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.mesEqipNm"
					>
					</search-input>
				</el-col>
				<!-- 담당자 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000982')"
						paramKey="userName"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.userName"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onUserPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 사용부서 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001321')"
						paramKey="useDeptNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.useDeptNm"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onDeptPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 교정업체 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001579')"
						paramKey="calInstCd"
						:options="calInstCdList"
						:propData="searchParams.calInstCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 가동상태 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001315')"
						paramKey="runStCd"
						:options="runStCdList"
						:propData="searchParams.runStCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 교정상태 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001316')"
						paramKey="calStCd"
						:options="calStCdList"
						:propData="searchParams.calStCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<!-- popup -->
		<user-popup-view ref="userPopupView" @SendData="sendUserData" :scrId="scrId" />
		<dept-mng-popup-view ref="deptPopupView" @SendData="sendDeptData" :scrId="scrId"></dept-mng-popup-view>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
import DeptMngPopupView from '@qms/comm/commpopup/DeptMngPopup/DeptMngPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			searchDateRange: []
		};
	},
	components: { SearchInput, SelectCombo, UserPopupView, DeptMngPopupView },
	async created() {
		this.$sf_toggleLoading(true);
		this.searchDateRange = [...this.getSearchDates_];
		await this.getCommCodesOnce_();
		await this.getMmcInstList_(); //교정업체 정보는 '부서관리'에서 관리함
		await this.searchList();
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isMmcAdmin) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				this.setState_({ key: 'resultList', value: [] });
				await this.getMesList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		setSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
			if (key === 'useDeptNm') {
				this.onDeptInPutKeyDown();
			}
			if (key === 'userName') {
				this.onUserInPutKeyDown();
			}
		},
		onUserPopup() {
			this.$refs.userPopupView.open(this.searchParams);
		},
		onDeptPopup() {
			this.$refs.deptPopupView.open(this.searchParams.useDeptNm);
		},
		sendUserData(userData) {
			this.setSearchParam_({ key: 'userId', value: userData.userId });
			this.setSearchParam_({ key: 'userName', value: userData.userName });
		},
		sendDeptData(deptData) {
			this.setSearchParam_({ key: 'useDeptCd', value: deptData.deptCd });
			this.setSearchParam_({ key: 'useDeptNm', value: deptData.deptNm });
		},
		onUserInPutKeyDown() {
			this.setSearchParam_({ key: 'userId', value: '' });
		},
		onDeptInPutKeyDown() {
			this.setSearchParam_({ key: 'useDeptCd', value: '' });
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
